import { useCallback } from 'react';

import { useAppDispatch } from '@/hooks/redux-hooks';
import { openExportDrawer } from '@/slices/drawerSlice';
import { setExport } from '@/slices/exportSlice';

export const ExportSelectionSource = {
  NAV_BAR: 'nav_bar',
  SYMBOL_SELECTOR: 'symbol_selector',
  WIDGET_BUTTON: 'widget_button',
  CHART_WIDGET_BUTTON: 'chart_widget_button'
} as const;

export type ExportSelectionSource =
  (typeof ExportSelectionSource)[keyof typeof ExportSelectionSource];

const useOpenExportSelection = (source?: ExportSelectionSource) => {
  const dispatch = useAppDispatch();

  return useCallback(() => {
    dispatch(setExport({}));
    dispatch(openExportDrawer({ showHistory: false, source }));
  }, [dispatch, source]);
};

export default useOpenExportSelection;
